import { AllowedCountriesProvider } from '@/context/allowedCountriesContext';
import WishlistContextProvider from '@/context/wishlistContext';
import { HydrationBoundary, QueryClientProvider } from '@tanstack/react-query';
import { ProvidersProps } from '@/types/props/providers';
import { SpiritoryModalProvider } from '../context/SpiritoryModalProvider';
import { UserBackendProvider } from '@/context/userBackendProvider';
import { ToastContainer } from 'react-toastify';
import { MobileBackgroundFocusProvider } from '@/context/MobileBackgroundFocusProvider';
import GTagEvents from '@/components/GTagEvents';
import GoogleCaptchaProvider from '@/context/GoogleCaptchaProvider';
import { SessionProvider } from '@/context/SessionContext';

export default function Providers({ children, pageProps, queryClient }: ProvidersProps) {
  return (
    <GoogleCaptchaProvider>
      <QueryClientProvider client={queryClient}>
        <HydrationBoundary state={pageProps.dehydratedState}>
          <SessionProvider sessionToken={pageProps.sessionToken}>
            <UserBackendProvider userSSR={pageProps.user} isStaticPage={pageProps.isStaticPage}>
              <AllowedCountriesProvider>
                <WishlistContextProvider>
                  <SpiritoryModalProvider>
                    <MobileBackgroundFocusProvider>{children}</MobileBackgroundFocusProvider>
                    <ToastContainer
                      position="top-center"
                      autoClose={5000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      theme="colored"
                      className="tw-z-[9999999999]"
                    />
                    <GTagEvents
                      recentlySignedIn={pageProps.recentlySignedIn}
                      recentlySignedUp={pageProps.recentlySignedUp}
                    />
                  </SpiritoryModalProvider>
                </WishlistContextProvider>
              </AllowedCountriesProvider>
            </UserBackendProvider>
          </SessionProvider>
        </HydrationBoundary>
      </QueryClientProvider>
    </GoogleCaptchaProvider>
  );
}
